// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__lYIHO","content":"Consent_content__2pqRg","footer":"Consent_footer__2as-j"};